module.exports = __webpack_public_path__ + "media/images/gallery/constellations/auriga/aur_names-3710c72f0bb1d9a34b7e6629efe4636f.gif";